
export const VideoDownloadEndpoint={
    VIDEO_DOWNLOAD_API:process.env.REACT_APP_BASE_URL+"/download",
}